import { toast } from "react-toastify";
import { SecondaryButton } from "@graffer-inc/console-design-kit";
import { useClipboardText } from "../../../../utils/use-clipboard";

interface PublishedUrlButtonProps {
  url: string;
}

export const PublishedUrlCopyButton = (props: PublishedUrlButtonProps) => {
  const { buttonRef } = useClipboardText(props.url, () => {
    toast.success("クリップボードにコピーしました");
  });

  return (
    <span ref={buttonRef}>
      <SecondaryButton
        text={"公開用URLをコピー"}
        onClick={(e) => {
          e.preventDefault();
        }}
        title={props.url}
      />
    </span>
  );
};
